/**
 * Client selection handlers for Dashboard action buttons
 * Extracted to separate file following 10-line rule
 */

import type { NavigateFunction } from 'react-router-dom';
import type { Client } from '@/lib/types';

/**
 * Handle action button click when no client is selected
 * Shows popover with options to select or create client
 */
export function handleActionWithoutClient(
  navigate: NavigateFunction,
  openSelectDialog: () => void
): void {
  // This function is called to prepare for showing a popover
  // The actual popover UI is handled in the Dashboard component
  // This handler can be extended to log analytics or perform other side effects
  openSelectDialog();
}

/**
 * Handle "New Assessment" button click when client is selected
 */
export function handleNewAssessment(
  navigate: NavigateFunction,
  client: Client
): void {
  navigate('/sop-assessment');
}

/**
 * Handle "Start Analysis" button click when client is selected
 */
export function handleStartAnalysis(
  navigate: NavigateFunction,
  client: Client
): void {
  navigate('/posture-analysis');
}

/**
 * Handle "Remote Assessment" button click when client is selected
 */
export function handleRemoteAssessment(
  navigate: NavigateFunction,
  client: Client
): void {
  navigate('/remote-assessment');
}

/**
 * Handle "Plan Drills" button click when client is selected
 */
export function handlePlanDrills(
  navigate: NavigateFunction,
  client: Client,
  isMobile: boolean
): void {
  navigate(isMobile ? '/drills' : '/drill-planner');
}

